var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-list',{attrs:{"cols-map":_vm.colsMap,"sort-by":"-price","items":_vm.value,"id":"account-card-list"},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('account-card',{key:item._id,staticClass:"fit",attrs:{"value":item},on:{"bought":function($event){return _vm.$emit('bought', $event)}}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }